import { motion } from "framer-motion";
import { REAL, GALLERY, BUSINESS } from "@/data";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 } }),
};

export const Gallery = () => (
  <section id="gallery" className="border-b border-black bg-white" data-testid="gallery-section">
    <div className="mx-auto max-w-[1400px] px-4 sm:px-8 py-20 lg:py-28">
      <div className="mb-3 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[#FF4E00]">
        <span className="h-px w-8 bg-[#FF4E00]" /> On The Job
      </div>
      <h2 className="font-anton text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tighter max-w-3xl">
        Real trucks. Real hauls.
      </h2>
      <p className="mt-4 max-w-lg text-muted-foreground">
        These are our own dumpsters out across {BUSINESS.county} — you fill it, we remove it.
      </p>

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={g.caption}
            custom={i}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            variants={reveal}
            data-testid={`gallery-item-${i}`}
            className={`group relative overflow-hidden border-2 border-black ${g.tall ? "md:row-span-2" : ""}`}
          >
            <img
              src={g.src}
              alt={g.caption}
              className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${g.tall ? "h-72 md:h-full" : "h-72"}`}
            />
            <div className="pointer-events-none absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/20" />
            <figcaption className="absolute bottom-0 left-0 bg-black px-4 py-2 font-bebas text-xl tracking-wide text-white">
              {g.caption}
            </figcaption>
          </motion.figure>
        ))}

        {/* Flyer promo tile */}
        <motion.div
          custom={3}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={reveal}
          data-testid="gallery-flyer"
          className="group relative overflow-hidden border-2 border-black md:col-span-2"
        >
          <img
            src={REAL.flyer}
            alt="Moe's Dump & Junk — dumpster rentals starting at $100 for the first 24 hours"
            className="h-full max-h-[520px] w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
          />
        </motion.div>
      </div>

      <div className="mt-6 flex flex-wrap gap-x-2 gap-y-3">
        {["Garbage / Attic Junk", "Landscaping Debris", "Construction Debris", "Roofing Material", "Licensed & Insured"].map((t) => (
          <span key={t} className="border border-black px-3 py-2 text-xs font-bold uppercase tracking-wide">
            {t}
          </span>
        ))}
      </div>
    </div>
  </section>
);
